// extracted by mini-css-extract-plugin
export default {"tags":"mr96Hi","link":"z15c9i"};